// FAQ Accordion
document.querySelectorAll('.js-toggle-faq').forEach((handler) => {
    handler.addEventListener('click', function(event) {
        event.preventDefault();

        this.closest('.faq').classList.toggle('faq--open');
    });
});